import React, { ReactElement } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeGrid } from 'react-window';
import { Sheet } from 'records/Sheet';
import { isEqual } from 'lodash';
import PublishedDrawingRenderer from './PublishedDrawingRenderer';

interface RenderingProps {
  style: React.CSSProperties;
  data: Sheet[][];
  columnIndex: number;
  rowIndex: number;
}

interface StyleProps {
  height: number;
  width: number;
}

interface Props {
  numberOfColumns: number;
  numberOfRows: number;
  sheetGrid: Sheet[][];
  handleSheetClick: (sheet: Sheet) => Promise<void>;
}

function DrawingGrid({
  numberOfColumns,
  numberOfRows,
  sheetGrid,
  handleSheetClick,
}: Props): ReactElement {
  return (
    <AutoSizer>
      {({ height, width }: StyleProps) => (
        <FixedSizeGrid
          columnCount={numberOfColumns}
          columnWidth={width / numberOfColumns}
          height={height}
          rowCount={numberOfRows}
          rowHeight={width / numberOfColumns}
          width={width}
          itemData={sheetGrid}
          style={{ overflowX: 'hidden' }}
        >
          {({ style, data, columnIndex, rowIndex }: RenderingProps) =>
            PublishedDrawingRenderer(
              style,
              data,
              columnIndex,
              rowIndex,
              handleSheetClick
            )
          }
        </FixedSizeGrid>
      )}
    </AutoSizer>
  );
}

function areEqual(
  prevProps: { sheetGrid: Sheet[][] },
  nextProps: { sheetGrid: Sheet[][] }
): boolean {
  return (
    prevProps === nextProps || isEqual(prevProps.sheetGrid, nextProps.sheetGrid)
  );
}

const MemoizedGrid = React.memo(DrawingGrid, areEqual);

export default MemoizedGrid;
